import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState, type ChangeEvent } from 'react';
import classnames from 'classnames';
import { Button, Icon, IconSize, InputFooter, InputHeader } from '@sbt-web/ui';
import { ERRORS_LABEL, getError } from '../../utils/errors';
import { Attach } from './Icons';
import styles from './index.module.scss';
interface AttachmentFieldProps {
  placeholder: string;
  name: string;
  onChange: (files: File | undefined) => void;
  errors: string[];
}
export const ERRORS_CODE = ['REPLY:attachment-size-invalid', 'REPLY:attachment-name-long', 'REPLY:attachment-name-short', 'REPLY:unsupported-attachment', 'REPLY:too-large-request'];
export const AttachmentField = t0 => {
  const $ = _c(35);
  const {
    placeholder,
    name,
    onChange,
    errors
  } = t0;
  const [labelText, setLabelText] = useState(placeholder);
  const [hasFile, setHasFile] = useState(false);
  const [error, setError] = useState();
  const inputRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== errors) {
    t1 = () => {
      const code = getError(errors, ERRORS_CODE);
      if (code) {
        setError(ERRORS_LABEL[code]);
      }
    };
    t2 = [errors];
    $[0] = errors;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onChange) {
    t3 = event => {
      const files = event.target.files;
      if (files && files?.length > 0) {
        setLabelText(files[0].name);
        setHasFile(true);
        setError(undefined);
        onChange(files[0]);
      }
    };
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleChange = t3;
  let t4;
  if ($[5] !== onChange || $[6] !== placeholder) {
    t4 = () => {
      setLabelText(placeholder);
      setHasFile(false);
      setError(undefined);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      onChange(undefined);
    };
    $[5] = onChange;
    $[6] = placeholder;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleRemoveFile = t4;
  let t5;
  if ($[8] !== name) {
    t5 = <InputHeader name={name} label="Curriculum" />;
    $[8] = name;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleChange || $[11] !== name) {
    t6 = <input ref={inputRef} className={styles.fileInput} id={name} type="file" name={name} accept=".pdf,.rtf" onChange={handleChange} />;
    $[10] = handleChange;
    $[11] = name;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== hasFile) {
    t7 = classnames(styles.fakeFileInput, {
      [styles.withFile]: hasFile
    });
    $[13] = hasFile;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== hasFile) {
    t8 = !hasFile && <Attach />;
    $[15] = hasFile;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== labelText || $[18] !== name || $[19] !== t7 || $[20] !== t8) {
    t9 = <label className={t7} htmlFor={name}>{t8}{labelText}</label>;
    $[17] = labelText;
    $[18] = name;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleRemoveFile || $[23] !== hasFile) {
    t10 = hasFile && <Button design="text" onClick={handleRemoveFile} size="medium" icon={<Icon name="Bin" iconSize={IconSize.MD} />} aria-label="elimina curriculum" />;
    $[22] = handleRemoveFile;
    $[23] = hasFile;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t6 || $[27] !== t9) {
    t11 = <div className={styles.container}>{t6}{t9}{t10}</div>;
    $[25] = t10;
    $[26] = t6;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== error) {
    t12 = error && <InputFooter message={error} isError={true} />;
    $[29] = error;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t5) {
    t13 = <div id="attachment_component">{t5}{t11}{t12}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t5;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};